import { useQuery } from "@tanstack/react-query";
import apiClient from "../client";

export const TRADINGVIEW_SCRIPTS_KEY = ["tradingview-scripts"] as const;

/** A strategy script staff invited the customer's current TradingView username to. */
export interface TradingViewScriptDto {
  tradingStrategyId: string;
  tradingViewUsername: string;
  invitedAt: string;
}

interface ListTradingViewScriptsResponse {
  items: TradingViewScriptDto[];
}

/** Only the current username's invites: after a change, the old one's no longer count. */
export function useTradingViewScripts(options?: { enabled?: boolean }) {
  return useQuery<TradingViewScriptDto[]>({
    queryKey: TRADINGVIEW_SCRIPTS_KEY,
    queryFn: async () => {
      const res = await apiClient.get<ListTradingViewScriptsResponse>("/customers/me/tradingview-scripts");
      return res.data.items;
    },
    enabled: options?.enabled ?? true,
  });
}
